import React from 'react';
import './rc.scss';

// Source: https://loading.io/css/

const RefreshingContent = () => {
    return (
        <div className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default RefreshingContent;
